import { RadioGroup, RadioGroupItem } from "@choose/ui/radio-group";
import { Separator } from "@choose/ui/separator";
import { createFileRoute } from "@tanstack/react-router";
import { useTheme } from "next-themes";
import { useTranslation } from "react-i18next";

import { LanguageForm } from "~/components/common/settings/members/language-form";
import { useCurrentUserQuery } from "~/graphql/graphql.gen";
import { getThemeOptions } from "~/stores/users-store";

export const Route = createFileRoute(
  "/_auth/_app_shell/_settings-navigation/settings/preferences",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();
  const { data: currentUser } = useCurrentUserQuery(undefined, {
    select: (data) => data.currentUser,
  });

  const themeOptions = getThemeOptions(t).toSorted((a, b) => {
    const map = new Map<string, number>();
    map.set("system", 0);
    map.set("light", 1);
    map.set("dark", 2);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (map.get(a.value)! < map.get(b.value)!) {
      return -1;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (map.get(a.value)! > map.get(b.value)!) {
      return 1;
    }
    return 0;
  });

  return (
    <>
      <title>{`${t("settings.preferences.title")} - ${t("app_name")}`}</title>
      <div className="bg-background w-full overflow-auto">
        <div className="m-auto max-w-2xl p-8">
          <header className="mt-14">
            <h1 className="text-2xl">{t("settings.preferences.title")}</h1>
            <span className="text-muted-foreground mt-1 text-sm">
              {t("settings.preferences.subtitle")}
            </span>
          </header>
          <Separator className="my-8" />
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-4">
              <h2 className="text-xl">{t("settings.preferences.theme")}</h2>
              <RadioGroup
                defaultValue={theme}
                onValueChange={setTheme}
                className="grid grid-cols-3 gap-4"
              >
                {themeOptions.map((option) => (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label
                    key={option.value}
                    className="flex cursor-pointer flex-col gap-2"
                  >
                    <option.illustration />
                    <div className="flex items-center gap-2">
                      <RadioGroupItem
                        value={option.value}
                        className="h-4 w-4"
                      />
                      <div className="text-sm font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                        {option.label}
                      </div>
                    </div>
                  </label>
                ))}
              </RadioGroup>
            </div>
            {currentUser ? <LanguageForm user={currentUser} /> : null}
          </div>
        </div>
      </div>
    </>
  );
}
